import Tags from "../../components/Tags";

export default function TagsScreen(){
return <Tags />
}